import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class SelectionModalButton extends Component {
  static propTypes = {
    iconSrc: PropTypes.string,
    children: PropTypes.any,
    title: PropTypes.string,
    onClick: PropTypes.func.isRequired,
    selected: PropTypes.bool
  };

  render() {
    const { onClick, selected, iconSrc, title } = this.props;
    return (
      <div className={`selection-modal-button ${selected && ' selected'}`} onClick={onClick}>
        {iconSrc && <div className="select-modal-icon"><img src={iconSrc}/></div>}
        <div className="select-modal-description">
          {title && <h3 className="select-modal-title">{title}</h3>}
          {this.props.children}
        </div>
      </div>
    );
  }
}
